var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z",
    fill: "url(#paint0_linear_1_1809)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 10C20.5304 10 21.0391 10.2107 21.4142 10.5858C21.7893 10.9609 22 11.4696 22 12C22 12.74 21.6 13.39 21 13.73V15H22C23.8565 15 25.637 15.7375 26.9497 17.0503C28.2625 18.363 29 20.1435 29 22H30C30.2652 22 30.5196 22.1054 30.7071 22.2929C30.8946 22.4804 31 22.7348 31 23V26C31 26.2652 30.8946 26.5196 30.7071 26.7071C30.5196 26.8946 30.2652 27 30 27H29V28C29 28.5304 28.7893 29.0391 28.4142 29.4142C28.0391 29.7893 27.5304 30 27 30H13C12.4696 30 11.9609 29.7893 11.5858 29.4142C11.2107 29.0391 11 28.5304 11 28V27H10C9.73478 27 9.48043 26.8946 9.29289 26.7071C9.10536 26.5196 9 26.2652 9 26V23C9 22.7348 9.10536 22.4804 9.29289 22.2929C9.48043 22.1054 9.73478 22 10 22H11C11 20.1435 11.7375 18.363 13.0503 17.0503C14.363 15.7375 16.1435 15 18 15H19V13.73C18.4 13.39 18 12.74 18 12C18 11.4696 18.2107 10.9609 18.5858 10.5858C18.9609 10.2107 19.4696 10 20 10ZM15.5 21C14.837 21 14.2011 21.2634 13.7322 21.7322C13.2634 22.2011 13 22.837 13 23.5C13 24.163 13.2634 24.7989 13.7322 25.2678C14.2011 25.7366 14.837 26 15.5 26C16.163 26 16.7989 25.7366 17.2678 25.2678C17.7366 24.7989 18 24.163 18 23.5C18 22.837 17.7366 22.2011 17.2678 21.7322C16.7989 21.2634 16.163 21 15.5 21ZM24.5 21C23.837 21 23.2011 21.2634 22.7322 21.7322C22.2634 22.2011 22 22.837 22 23.5C22 24.163 22.2634 24.7989 22.7322 25.2678C23.2011 25.7366 23.837 26 24.5 26C25.163 26 25.7989 25.7366 26.2678 25.2678C26.7366 24.7989 27 24.163 27 23.5C27 22.837 26.7366 22.2011 26.2678 21.7322C25.7989 21.2634 25.163 21 24.5 21Z",
    fill: "#FCFBFB"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_1809",
    x1: 20,
    y1: 0,
    x2: 20,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B4C84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D56F3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.911865e15600f64f228356cdf54c121b.svg";
export { ForwardRef as ReactComponent };